<template>
    <div>
        <p class="font-semibold" style="margin-bottom: -1.5rem">{{params.data.calleeMem}}</p>
        <p style="color: #a0aec0;" v-if="params.data.type_call == 'INCALL' || params.data.type_call == 'MISSCALL'">{{params.data.hotline_number}}</p>
        <p style="color: #a0aec0;" v-else>{{params.data.calleeMemPhone}}</p>
    </div>
</template>

<script>
export default {
    name: "CellRendererCallee"
}
</script>

<style scoped>

</style>
